export enum PasswordComponentEnum {
	Password = 'Set Your Password',
	ResetPassword = 'Reset Your Password'
}
